<template>
  <div>
    <v-form ref="formEditCoureur" v-model="valid" class="mb-5 mt-4"
      v-if="inscription.list_courses && inscription.coureur.champs">
      <v-row v-if="inscription.list_courses.count_selected() > 0">
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Dossard</label>
          <v-text-field type="number" v-model="inscription.dossard" ref="fielddoss"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6" cols="12" class="py-0" v-for="(champ, index_champ) in inscription.coureur.champs"
          :key="index_champ">
          <div>


            <div v-if="champ.nom == 'ville'">
              <Champ_Select_Ville v-if="is_commune_francaise" :champ="champ" :cp="inscription.coureur.champs.cp.value"
                :inscription="inscription" mode="admin"></Champ_Select_Ville>
              <Champ_Text v-else :champ="champ" :inscription="inscription" mode="admin"></Champ_Text>
            </div>
            <div v-else-if="champ.nom == 'licence'">
              <Champ_Licence :champ="champ" :inscription="inscription" mode="admin"></Champ_Licence>
            </div>
            <div v-else-if="champ.nom == 'numero_pps'">
              <Champ_PPS :champ="champ" :inscription="inscription" mode="admin"></Champ_PPS>
            </div>
            <div v-else-if="champ.nom == 'numero_licence_ffr'">
              <Champ_Licence_FFR :champ="champ" :inscription="inscription" mode="admin"></Champ_Licence_FFR>

            </div>

            <div v-else-if="champ.nom == 'date_naissance'">
              <Champ_Date_Naissance :champ="champ" :inscription="inscription">
              </Champ_Date_Naissance>
            </div>
            <div v-else>
              <Champ_Text v-if="champ.type == 'text' || champ.type == 'tel'" :champ="champ" :inscription="inscription"
                mode="admin"></Champ_Text>
              <Champ_Select v-if="champ.type == 'select'" :champ="champ" :inscription="inscription" mode="admin">
              </Champ_Select>
              <Champ_Select_Multiple v-if="champ.type == 'select_multiple'" :champ="champ" :inscription="inscription"
                mode="admin">
              </Champ_Select_Multiple>
              <Champ_Date v-if="champ.type == 'date'" :champ="champ" :inscription="inscription" mode="admin">
              </Champ_Date>
              <Champ_Number v-if="champ.type == 'number'" :champ="champ" :inscription="inscription" mode="admin">
              </Champ_Number>
              <Champ_Boolean v-if="champ.type == 'boolean'" :champ="champ" :inscription="inscription" mode="admin">
              </Champ_Boolean>
              <Champ_Document v-if="champ.type == 'document'" :champ="champ" :inscription="inscription" mode="admin">
              </Champ_Document>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col>
          <div class="text-h6 mt-2 mb-4">Statut de l'inscription</div>
          <div class="d-flex">
            <v-switch v-model="inscription.affiche" color="primary-dark" hide-details true-value="1" false-value="0"
              label="Affichée?"></v-switch>
            <!-- <v-switch v-model="inscription.paye" color="primary-dark" hide-details true-value="1" false-value="0" label="Payée?"></v-switch> -->
            <v-switch v-model="inscription.document_recu" color="primary-dark" hide-details true-value="1"
              false-value="0" label="Document reçu?"></v-switch>
            <v-switch v-model="inscription.document_valide" color="primary-dark" hide-details true-value="1"
              false-value="0" label="Document validé?"></v-switch>
            <v-switch v-model="inscription.valide" color="primary-dark" hide-details true-value="1" false-value="0"
              label="Validée?"></v-switch>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col md="4" cols="12">
          <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn" variant="tonal" @click="validate">
            <v-icon icon="mdi-arrow-right-bold"></v-icon> Enregistrer les modifications </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors" :key="index_error"
      type="error">
      {{ error }}
    </v-alert>
    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Modification des informations</div>
          <p>L'inscription de {{ inscription.nom }} {{ inscription.prenom }} à bien été mise à jour.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="display_confirm_dialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Champ_Text from "@/components/Inscription/Champs_Formulaire/Champ_Text.vue";
import Champ_Select from "@/components/Inscription/Champs_Formulaire/Champ_Select.vue";
import Champ_Select_Multiple from "@/components/Inscription/Champs_Formulaire/Champ_Select_Multiple.vue";
import Champ_Date from "@/components/Inscription/Champs_Formulaire/Champ_Date.vue";
import Champ_Date_Naissance from "@/components/Inscription/Champs_Formulaire/Champ_Date_Naissance.vue";
import Champ_Number from "@/components/Inscription/Champs_Formulaire/Champ_Number.vue";
import Champ_Boolean from "@/components/Inscription/Champs_Formulaire/Champ_Boolean.vue";
import Champ_Document from "@/components/Inscription/Champs_Formulaire/Champ_Document.vue";
import Champ_Select_Ville from "@/components/Inscription/Champs_Formulaire/Champ_Select_Ville.vue";
import Champ_Licence from "@/components/Inscription/Champs_Formulaire/Champ_Licence.vue";
import Champ_PPS from "@/components/Inscription/Champs_Formulaire/Champ_PPS.vue";
import Champ_Licence_FFR from "@/components/Inscription/Champs_Formulaire/Champ_Licence_FFR.vue";


export default {
  props: ["item"],
  components: {
    Champ_Text,
    Champ_Select,
    Champ_Select_Multiple,
    Champ_Date,
    Champ_Number,
    Champ_Boolean,
    Champ_Document,
    Champ_Select_Ville,
    Champ_Licence,
    Champ_PPS,
    Champ_Licence_FFR,

    Champ_Date_Naissance,
  },
  data() {
    return {
      valid: false,
      errors: [],
      display_confirm_dialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    is_commune_francaise() {
      return this.inscription.coureur.champs.pays && this.inscription.coureur.champs.pays.value == "FRA" && this.inscription.coureur.champs.cp && this.inscription.coureur.champs.cp.value.length == 5;
    },
  },
  methods: {
    async validate() {
      this.errors = [];
      let res = await this.$refs.formEditCoureur.validate();

      if (res.valid) {
        let update_coureur = await this.inscription.update_informations_coureur_admin(this.mainStore.authAdmin.adminData.username);
        if (update_coureur) {
          this.display_confirm_dialog = true;
        } else {
          this.errors.push("Une erreur est survenue lors de la modification de vos informations. Merci de réessayer ultérieurement.");
        }
      } else {
        this.errors.push("Certains champs nécessitent votre attention, merci de les vérifier avant de continuer.");
      }
    },
  },
  created() {
    this.inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>